import { Graph } from "@antv/x6"

Graph.registerReactComponent('my-component1', (node) => {
	const data = node.getData()
	return (<div>{123}</div>)
})
